import React, { useState } from 'react';
import { Modal, Button } from '../../../components';
import css from './WishlistModal.module.css';
import {
  updateInProgressSelector,
  updateProfile,
} from '../../ProfileSettingsPage/ProfileSettingsPage.duck';
import { useDispatch, useSelector } from 'react-redux';
import { getWishlist, isArrayLength, upsertWishlistItem } from '../../../util/dataExtractors';
import { currentUserSelector } from '../../../ducks/user.duck';

function WishlistModal(props) {
  const {
    onManageDisableScrolling,
    isWishlistModalOpen,
    onToggleWishlistModal,
    listings,
    intl,
    selectedWishlistItem: wishlistItem, // listingId
  } = props;

  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserSelector);
  const updateInProgress = useSelector(updateInProgressSelector);

  // User's current wishlist array
  const wishlistItems = getWishlist(currentUser) || [];

  const [showCreateWishlist, setShowCreateWishlist] = useState(false);
  const [newWishlistName, setNewWishlistName] = useState('');

  const handleClose = () => {
    onToggleWishlistModal(false);
    setShowCreateWishlist(false);
    setNewWishlistName('');
  };

  const handleCreateWishlist = () => {
    setShowCreateWishlist(true);
  };

  const handleWishlistNameChange = event => {
    setNewWishlistName(event.target.value);
  };

  const saveWishlist = wishlistName => {
    if (!wishlistItem) {
      console.error('No wishlist item (listingId) found!');
      return;
    }

    const finalName = wishlistName || newWishlistName.trim();
    if (!finalName) return;

    const updatedWishlist = upsertWishlistItem(currentUser, {
      wishlistItem,
      wishlistName: finalName,
      listings,
    });

    dispatch(
      updateProfile({
        protectedData: {
          ...currentUser?.attributes?.profile?.protectedData,
          wishlist: updatedWishlist,
        },
      })
    ).then(() => {
      handleClose();
    });
  };

  const createNewListContent = (
    <div className={css.createWishlist}>
      <div className={css.formFld}>
        <label htmlFor="newWishlistName">{intl.formatMessage({ id: 'WishlistModal.title' })}</label>

        <input
          type="text"
          value={newWishlistName}
          onChange={handleWishlistNameChange}
          placeholder={intl.formatMessage({ id: 'WishlistModal.titlePlacehodler' })}
        />
      </div>

      <Button
        inProgress={updateInProgress}
        disabled={!newWishlistName.trim()}
        onClick={() => saveWishlist(newWishlistName)}
      >
        {intl.formatMessage({ id: 'WishlistModal.saveWishlist' })}
      </Button>
    </div>
  );

  const selectListContent = (
    <div className={css.wishlistOverview}>
      <div className={css.wishlistContent}>
        {isArrayLength(wishlistItems) &&
          wishlistItems.map(wl => (
            <div key={wl?.name} className={css.wishlistItem} onClick={() => saveWishlist(wl?.name)}>
              <div className={css.wishlistImg}>
                <img src={wl?.coverImage} alt={wl?.name} />
              </div>

              <h2>{wl?.name}</h2>

              <p>
                {wl?.ids?.length} {intl.formatMessage({ id: 'WishlistModal.saved' })}
              </p>
            </div>
          ))}
      </div>

      <Button inProgress={updateInProgress} onClick={handleCreateWishlist}>
        {intl.formatMessage({ id: 'WishlistModal.createNewWishlist' })}
      </Button>
    </div>
  );

  return (
    <Modal
      id="Wishlist.modal"
      isOpen={isWishlistModalOpen}
      onClose={handleClose}
      onManageDisableScrolling={onManageDisableScrolling}
      modalTitle={intl.formatMessage({
        id: showCreateWishlist ? 'WishlistModal.createList' : 'WishlistModal.addToList',
      })}
    >
      {showCreateWishlist ? createNewListContent : selectListContent}
    </Modal>
  );
}

export default WishlistModal;
